import PersonaPage from "./PersonaPage";
import { questionsFriend } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für einen Freund oder eine Freundin?",
    a: "Freundschaft ist gewählte Familie. Beginnen Sie mit dem Moment, an dem klar wurde, dass Sie füreinander da sein werden. Von dort aus schreibt sich die Rede fast von selbst.",
  },
  {
    q: "Wie bleibt eine Freundesrede würdig ohne pathetisch zu werden?",
    a: "Durch das konkrete Detail. Ein Insider, ein Ritual, ein Satz, den nur Sie beide verstanden — genau das trägt Würde, weil es echt ist. Kein leerer Pathos.",
  },
  {
    q: "Darf ich vor der Familie meines Freundes sprechen?",
    a: "Ja — und es kann für die Familie sehr tröstlich sein. Eine Rede von einem engen Freund zeigt Facetten, die nur Freundschaft sieht.",
  },
  {
    q: "Was, wenn ich vor Emotionen kaum sprechen kann?",
    a: "Viele lesen ihre Rede an diesem Tag ruhiger vor, als sie befürchtet haben. Wir schreiben den Entwurf so, dass er auch mit Pausen trägt.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für einen Kollegen", to: "/trauerrede-kollege" },
  { label: "Trauerrede für den Bruder", to: "/trauerrede-bruder" },
  { label: "Trauerrede für die Schwester", to: "/trauerrede-schwester" },
];

export default function TrauerredeFreund() {
  return (
    <PersonaPage
      slug="trauerrede-freund"
      metaTitle="Trauerrede für einen Freund schreiben — für Freundin & Freund | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für einen Freund oder eine Freundin. Freundschaft ist gewählte Familie — der Entwurf trägt genau diesen Ton. Ab 29 €."
      eyebrow="Trauerrede · Freund · Freundin"
      headline={
        <>
          Eine Trauerrede für einen Freund.
          <br />
          <span className="italic text-umber">Gewählte Familie. In Ihren Worten.</span>
        </>
      }
      intro="Manche Menschen wählt man sich selbst. Sie werden zu Zeugen des eigenen Lebens — an ganz normalen Abenden, in ganz normalen Küchen. Ein behutsamer erster Entwurf für die Rede, die Sie ihm oder ihr schulden."
      heroImage="https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1920&q=80"
      heroImageAlt="Zwei Weingläser auf einer Terrasse im Abendlicht — Sinnbild einer Trauerrede für einen Freund"
      questions={questionsFriend}
      exampleQuote={
        <>
          „Wir haben uns kennengelernt, als wir beide noch nicht wussten, wer wir sein würden.
          Zwischen uns lagen einundzwanzig Jahre, drei Wohnungswechsel, zwei Krankenhausaufenthalte
          und ungefähr tausend Abende, an denen wir zu lange geblieben sind. Er hat mich nicht
          begleitet — er war Teil des Weges. Das ist ein Unterschied. Und den werde ich behalten.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
